<template>
  <div
    v-if="fieldObj.fieldInfo.fieldExtraType == 10"
    class="style1-wap align-left"
    :class="{
      err: fieldObj.dirty && fieldObj.invalid
    }"
  >
    <a-checkbox class="u-policy-container" @change="handleChange" :disabled="fieldObj.disabled" v-model="fieldObj.isSelected">
      <div class="u-policy-box" :class="policyClass()" v-html="fieldObj.privacyPolicyTitle"></div>
    </a-checkbox>
    <div class="u-reg-err-tips" v-if="fieldObj.dirty && fieldObj.invalid">
      {{ fieldObj.validationMessage }}
    </div>
  </div>
  <div
    v-else
    class="style1-wap"
    :class="{
      must: fieldObj.required == 1,
      err: fieldObj.dirty && fieldObj.invalid,
      statusNoBorder: fieldStyle == 'style2-wap'
    }"
  >
    <div class="u-label">
      {{ fieldObj.displayName }}
    </div>
    <div class="m-radio-list-wap">
      <div
        v-for="(o, i) in fieldObj.listOptions"
        :key="o.optionId"
        class="m-radio-wrapper"
      >
        <a-radio
          class="m-radio-item"
          :class="{
            'has-desc':
              fieldObj.options &&
              fieldObj.options[i] &&
              (fieldObj.options[i].optionDescText ||
                fieldObj.options[i].optionDescHrefText)
          }"
          @change="onChange"
          :value="o.optionId"
          :disabled="fieldObj.disabled || o.disabled"
          :checked="fieldObj.model.optionId == o.optionId"
        >
          {{ o.optionValue }}
          <div
            v-if="
              fieldObj.options &&
                fieldObj.options[i] &&
                fieldObj.options[i].optionDescText
            "
            class="u-desc"
          >
            {{ fieldObj.options[i].optionDescText }}
          </div>
          <div
            v-if="
              fieldObj.options &&
                fieldObj.options[i] &&
                fieldObj.options[i].optionDescHrefText
            "
            class="u-desc"
          >
            <a :href="fieldObj.options[i].optionDescHref">{{
              fieldObj.options[i].optionDescHrefText
            }}</a>
          </div>
        </a-radio>
        <input
          class="otherInput"
          v-if="o.otherisFillIn == 1 && fieldObj.model.optionId == o.optionId"
          type="text"
          v-model="o.otherValue"
          placeholder="请输入"
          @blur="inputBlur($event, o)"
        />
        <div
          class="u-reg-err-tips"
          v-if="
            o.checked &&
              o.otherisFillIn == 1 &&
              o.otherIsRequire == 1 &&
              !o.otherValue
          "
        >
          请填写
        </div>
      </div>
    </div>
    <div class="u-reg-err-tips" v-if="fieldObj.dirty && fieldObj.invalid">
      {{ fieldObj.validationMessage }}
    </div>
  </div>
</template>

<script>
import radioMixin from "../../field/new-fields/radio";
export default {
  name: "sk-radio-wap",
  mixins: [radioMixin]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.hello {
  text-align: left;
  padding: 20px;
}
.m-radio-wrapper {
  display: block;
  margin-bottom: 8px;
}
.otherInput {
  display: block;
  width: calc(100% - 24px);
  margin-top: 4px;
  margin-left: 24px;
  box-sizing: border-box;
}
.otherInput::placeholder {
  color: #d9d9d9;
}
.otherInput:disabled {
  cursor: not-allowed;
  background-color: #fff;
}
.u-reg-err-tips {
  padding-left: 24px;
}
.m-radio-item {
  display: flex;
  align-items: flex-start;
}
::v-deep .ant-radio-wrapper .ant-radio {
  top: 0.1em;
}
</style>
